import React from "react";
import { useLocation } from "react-router-dom";
import "../router/router.css";
import NavCustomDrawer from "../UI/drawerMain/drawer";
import CustomAppBar from "../UI/appBar/appBar";
import MobileDrawer from "../UI/menuBar/menuBar";

const Layout = ({
  children,
  isOpen,
  setIsOpen,
  logOut,
  login,
  surveyListing,
  getNotifications,
  setNotification,
  setTotalNotification,
  setRedirectValue,
}) => {
  const location = useLocation();
  
  return (
    <div className="div-post-login">
      <NavCustomDrawer
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        logOut={logOut}
        token={login.token}
        user_type={login.user_type}
        login={login}
        redirect={surveyListing.redirect_value}
        setRedirectValue={setRedirectValue}
        current_organisation={login.current_organisation}
      />
      <CustomAppBar
        logOut={logOut}
        token={login.token}
        userName={login.name}
        userEmail={login.email}
        isOpen={isOpen}
        login={login.isLoggedin}
        organisation_details={surveyListing.organisation_details}
        parent_organisation={login.parent_organisation}
        user_type={login.user_type}
        loginDetails={login}
        getNotifications={getNotifications}
        setNotification={setNotification}
        setTotalNotification={setTotalNotification}
      />
      <MobileDrawer
        logOut={logOut}
        token={login.token}
        user_type={login.user_type}
        current_organisation={login.current_organisation}
      />
      {children}
    </div>
  );
};

export default Layout;
